export default __webpack_public_path__ + "static/media/background.ecdbcae3.jpg";